import { Component, Input, OnChanges } from "@angular/core";
import { NotifierPropertiesService } from "../../models/notifier-properties.service";

@Component({
  selector: "ab-outdated-notifier-warning-alert",
  templateUrl: "./outdated-notifier-warning.component.html",
})
export class OutdatedNotifierWarningAlertComponent implements OnChanges {
  @Input() public projectId: number;
  public notifierName: any;
  public notifierUpgradeUrl: any;
  public notifierVersion: any;
  public show: boolean;

  constructor(private notifierPropertiesService: NotifierPropertiesService) {}

  public close() {
    this.show = false;
  }

  public ngOnChanges() {
    this.show = false;

    const params = { projectId: this.projectId };

    if (this.projectId == null) {
      return;
    }

    this.notifierPropertiesService.get(params).subscribe((props: any) => {
      this.notifierUpgradeUrl = props.notifier_upgrade_url;
      this.notifierName = props.notifier_name;
      this.notifierVersion = props.notifier_version;

      if (props.outdated_notifier === true) {
        this.show = true;
      }
    });
  }

  public goToUpgradeNotifierDoc() {
    window.open(this.notifierUpgradeUrl, "_blank");
  }
}
